import { MutationOptions, useMutation } from "react-query";
import { API_URL, APIError, APIResponse, post } from "../api";

function useSetSecurityQuestion<T>(
  options?: MutationOptions<
    APIResponse<T>,
    APIError,
    { security_question: string; security_answer: string }
  >
) {
  const {
    mutate: setSecurityQuestion,
    isLoading: savingSecurityQuestions,
    isError: isSetSecurityQuestionError,
    error: setSecurityQuestionError,
  } = useMutation(
    async (variables) =>
      await post(
        API_URL + "/account/user/security/create-security-question",
        variables,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      ),
    options
  );

  return {
    setSecurityQuestion,
    savingSecurityQuestions,
    isSetSecurityQuestionError,
    setSecurityQuestionError,
  };
}

export default useSetSecurityQuestion;
